import InertIcon from "./InertIcon";
import GroupItem from "./GroupItem";
import { resolveDemoIcon } from "../icons/defaultIcons";
import { countConversationsForGroup } from "../hooks/demoUtils";
import type { Conversation, InboxDemoIcons, InboxGroup } from "../data/types";

type GroupPanelProps = {
  groups: InboxGroup[];
  conversations: Conversation[];
  icons: InboxDemoIcons;
  selectedGroupId?: string;
  expandedGroupIds: string[];
  onToggle: (groupId: string) => void;
  onSelect: (groupId: string) => void;
};

export default function GroupPanel({
  groups,
  conversations,
  icons,
  selectedGroupId,
  expandedGroupIds,
  onToggle,
  onSelect,
}: GroupPanelProps) {
  return (
    <section className="hidden h-full w-40 shrink-0 flex-col overflow-hidden border-r border-default-100 px-2 md:flex">
      <div className="flex items-center gap-1 bg-content1 px-2 py-4">
        <InertIcon className="rounded-lg p-1 text-default-500">
          {resolveDemoIcon(icons, "groupBack")}
        </InertIcon>
        <p className="min-w-0 flex-1 text-base font-medium leading-6 text-default-foreground">
          分组
        </p>
      </div>
      <div className="inbox-demo-scroll flex min-h-0 flex-1 flex-col gap-1 pb-3">
        {groups.map((group) => (
          <GroupItem
            count={countConversationsForGroup(conversations, group.id)}
            expandedGroupIds={expandedGroupIds}
            group={group}
            icons={icons}
            key={group.id}
            selectedGroupId={selectedGroupId}
            onSelect={onSelect}
            onToggle={onToggle}
          />
        ))}
      </div>
    </section>
  );
}
